const IsNewClaimCondition = {
  isExistingClaimQuestion:
    "Have you made a claim with us for this condition in the last six months?",
  isExistingClaimChoice1: "yes",
  isExistingClaimChoice2: "no",
  isExistingClaimQuestionTooltip:
    "This is to help us identify whether we have details of the claim / condition on our systems to update or whether this is a new claim."
};

export default IsNewClaimCondition;
